const { ConsentName} = require('../constants/consentName');
const { permissionsConsent } = require('../constants/consentPermissions');
const { getConsentModeValue } = require('./getConsentModeValue');

/**
 * Checks consent against active admins and permissions list
 * @param {string[]} admins List of admins
 * @param {string[]} permissions List of permissions
 * @returns {Object} Object with checked consent
 */
const getCheckedConsent = (admins, permissions) => {
  const permissionsStorage = {
    [ConsentName.AdStorage]: [],
    [ConsentName.AnalyticsStorage]: [],
    [ConsentName.PersonalizationStorage]: []
  };

  let key;

  for (let i = 0; i < admins.length; i++) {
    for (let j = 0; j < permissions.length; j++) {
      key = permissionsConsent[permissions[j]];

      permissionsStorage[key].push(permissionsStorage[key] && window.WP.gdpr.check(permissions[j], admins[i]));
    }
  }

  return {
    [ConsentName.AdStorage]: getConsentModeValue(permissionsStorage[ConsentName.AdStorage]),
    [ConsentName.AnalyticsStorage]: getConsentModeValue(permissionsStorage[ConsentName.AnalyticsStorage]),
    [ConsentName.PersonalizationStorage]: getConsentModeValue(permissionsStorage[ConsentName.AnalyticsStorage])
  };
};

module.exports = { getCheckedConsent };
